import { Navigate, useLocation } from "react-router-dom";

interface UnprotectedRouteProps {
  element: React.ReactElement;
}

const UnprotectedRoute = ({ element }: UnprotectedRouteProps) => {
  const location = useLocation();
  const isAuthenticated = localStorage.getItem("access_token");
  const from = (location.state as { from?: string })?.from;
  return isAuthenticated ? <Navigate to={from ?? "/"} replace /> : element;
};

export default UnprotectedRoute;